<template>
    <div>
        <!-- 点击 Report information errors 后弹出 -->
        <div class="deep">
            <el-dialog :visible.sync="newDialog" center :close-on-click-modal="true" @close="closeDialog"
                custom-class="dialog_normalsuo" :append-to-body="true">
                <div class="detail_cont">
                    <h3>Order Report</h3>

                    <div class="rep_list">
                        <el-form ref="reportForm" :model="reportForm" class="report_form">
                            <div class="report_item">
                                <div class="report_form_box">
                                    <el-form ref="form" :model="form" class="form_box" label-position="left">
                                        <div class="fin_cont_box flex_center_between_box">
                                            <div class="fin_modu_box">
                                                <div class="fin_modu">
                                                    <el-form-item label="Company Name:">
                                                        <el-input :placeholder="$t('MyDatabase.Entercompanyname')"
                                                            v-model="form.CompanyName"></el-input>
                                                    </el-form-item>
                                                    <el-form-item label="Country:">
                                                        <el-select filterable v-model="form.Country"
                                                            :placeholder="$t('Home.selectCountry')">
                                                            <el-option v-for="item in Coutryoptions" :key="item.val"
                                                                :label="item.value" :value="item.val">
                                                            </el-option>
                                                        </el-select>
                                                    </el-form-item>
                                                    <el-form-item label="Co. ID:">
                                                        <el-input placeholder="Enter Co. ID"
                                                            v-model="form.RegisterID"></el-input>
                                                    </el-form-item>
                                                    <el-form-item label="Address:">
                                                        <el-input placeholder="Enter Address"
                                                            v-model="form.Address"></el-input>
                                                    </el-form-item>
                                                </div>
                                            </div>
                                        </div>
                                    </el-form>
                                    <el-form-item label="What can we help you with?(maximum 500 words)">
                                        <el-input v-model="form.demand" type="textarea" placeholder="Enter Content"
                                            class="limit_box" maxlength="500" @input="inputChange(form.demand)"
                                            show-word-limit></el-input>
                                    </el-form-item>
                                </div>

                                <div style="display: flex; justify-content: center">
                                    <el-button class="btn_cancel" @click="cancelReport()">Cancel</el-button>
                                    <el-button class="btn_export" @click="onSubmitReport()">Submit</el-button>
                                    <!-- <el-button class="btn_export" :disabled="disabledReport" @click="onSubmitReport()">Submit</el-button> -->
                                </div>
                            </div>
                        </el-form>
                    </div>
                </div>
            </el-dialog>
        </div>
    </div>
</template>
<script>
import { getUpdatdataFeedback } from '@/api/companyApi.js';
export default {
    props: {
        showReport: {
            type: Boolean,
            default: false,
        },
        powerStatus: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            Coutryoptions: [],
            // newDialog: true,
            tabName: 'Reportmycompany',
            finDialog: false,
            reportDialog2: false,

            form: {
                // year: new Date().getFullYear(),
                CompanyName: '',
                Country: '',
                RegisterID: '',
                Address: '',
                demand: '',
                // coreCompetency: [],
                // businessOutlook: '',
                // uploadFiles: [],
            },
            type: '701',
            filesList: [],

            disabledReport1: true,
            disabledReport2: true,
            disabledReport: true,
            reportForm: { subject: '', demand: '' },
            addReportList: [{ subject: '', demand: '' }],
        };
    },
    computed: {
        newDialog: {
            get() {
                return this.showReport;
            },
            set(newValue) { },
        },
    },

    mounted() {
        this.GetCountry();

        this.huixian();
    },
    methods: {
        GetCountry() {
            let Allcountry = JSON.parse(localStorage.getItem("countryList"))[0]
                .countryList;
            Allcountry.forEach((item) => {
                item.value = item.nameEn;
                item.val = item.countryCode;
            });
            this.Coutryoptions = Allcountry;
        },
        huixian() {
            this.form.CompanyName = this.$route.query.searchname;
        },
        //关闭弹窗
        closeDialog() {

            this.form.RegisterID = '',
                this.form.Country = ''
            this.form.demand = ''
            this.form.Address = ''
            this.$emit('closeReportDialog', false);
        },

        inputChange(val) {
            val.length > 0 ? (this.disabledReport2 = false) : (this.disabledReport2 = true);
            if (this.disabledReport1 == false && this.disabledReport2 == false) {
                this.disabledReport = false;
            } else {
                this.disabledReport = true;
            }
        },
        //提交report
        onSubmitReport() {
            this.hanldSubmitReport();
        },
        async hanldSubmitReport() {
            const name = this.$route.query.name;
            const id3a = this.$route.query.pid;

            let obj = {
                coId: this.form.RegisterID,
                // companyId: id3a,
                companyName: this.form.CompanyName,
                country: this.form.Country,
                demand: this.form.demand,
                address: this.form.Address,
            };
            let res = await getUpdatdataFeedback(obj);

            if (res.code == 200) {
                this.$message({
                    message: res.msg,
                    center: true,
                    type: 'success',
                });
                this.closeDialog();

            } else {
                this.$message({
                    message: res.msg,
                    center: true,
                    type: 'error',
                });
            }
        },
        //取消report
        cancelReport() {
            this.closeDialog();

        },
    },
};
</script>
<style scoped>
.form_box /deep/ .el-input__inner {
    width: 162px;
    height: 34px;
    line-height: 34px;
    background: #ffffff;
    border-radius: 8px;
    border: 1px solid #e7eaed;
    font-size: 1.2857143rem;
}






.form_box /deep/ .el-select .el-icon-arrow-up:before {
    color: #8497ab !important;
}


.fin_modu.last {
    height: 661px;
}

.form_box /deep/ .el-form-item__content {
    line-height: 34px;
    margin-left: 162px;
    font-size: 1.2857143rem;
}

/deep/ .el-form-item__label {
    color: #1A2332;
     font-size: 1.2857143rem;
    margin-bottom: 10px;
}

.form_box /deep/ .el-form-item__label {
    display: flex;
    align-items: center;
    color: #1A2332;
    font-size: 1.2857143rem;
    height: 50px;
    line-height: 50px;


}

.form_box /deep/ .el-form-item {
    margin-bottom: 12px;
    display: inline-block;
   font-size: 1.2857143rem;
}


.form_box /deep/ .out_item {
    margin-bottom: 20px;
}

.form_box /deep/ .el-input__icon {
    height: auto;
}



.rep_list {
    padding-bottom: 10px;
}



.report_form_box {
    margin-top: 1.4285714rem;
    margin-bottom: 20px;

}

.report_form /deep/ .el-input__inner {
    width: 420px;
    height: 50px;
    line-height: 50px;
}

.report_form /deep/ .el-form-item {
    margin-bottom: 1rem;
}

.limit_box /deep/ .el-textarea__inner {
    height: 150px;
}

.detail_cont {}
</style>
